// Thanks: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
import { tryOnBeforeMount, useEventListener } from '@vueuse/core'
import { ref } from 'vue'

export const useDynamicVhCssProperty = () => {
  const vh = ref(0)

  const updateVh = () => {
    vh.value = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh.value}px`)
  }

  tryOnBeforeMount(() => {
    updateVh()
    useEventListener('resize', updateVh)
  })
}
